import React from 'react';
import { Tabs } from '../../../ui/Tabs';
import type { BedroomOption } from './hooks/useFloorplansByBedroom';
import * as styles from './unitsModule.styles';

type BedroomTabsProps = {
  options: Array<BedroomOption>;
  activeBeds: number;
  onTabChange: (beds: number) => void;
};

export const BedroomTabs = ({ options, activeBeds, onTabChange }: BedroomTabsProps) => {
  const tabs = options.map((o) => ({ id: String(o.beds), label: o.label }));

  return (
    <Tabs
      tabs={tabs}
      activeTabId={String(activeBeds)}
      onTabChange={(id) => onTabChange(Number(id))}
      ariaLabel="Filter by bedrooms"
      idPrefix="bedroom-tab"
      tabClassName={styles.bedroomTab}
    />
  );
};
